module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu-lateral"
    }
  }, [_c('div', {
    staticClass: "page-sidebar",
    attrs: {
      "data-pages": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-overlay-slide from-top",
    attrs: {
      "id": "appMenu"
    }
  }), _c('div', {
    staticClass: "sidebar-header"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.home
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSelectedMenuItem()
      }
    }
  })], 1), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('ul', [(_vm.isLoadingData) ? _c('li', {
    staticClass: "loading-functionalities"
  }, [_c('img', {
    attrs: {
      "src": _vm.loadingGif
    }
  })]) : _vm._l((_vm.functionalitiesGroup), function(grupo) {
    return _c('li', {
      class: {
        "active": grupo.active,
        "selected": grupo.selected
      },
      attrs: {
        "id": grupo.key
      }
    }, [_c('a', {
      staticClass: "group",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.groupClicked(grupo)
        }
      }
    }, [_c('div', {
      staticClass: "group-icon"
    }, [_c('i', {
      staticClass: "fa",
      class: grupo.icone
    })]), _c('p', {
      staticClass: "group-text"
    }, [_vm._v(_vm._s(grupo.text))])]), _c('ul', {
      staticClass: "group-options",
      class: grupo.selected ? "is-expanded" : "is-collapsed"
    }, [_c('span', {
      staticClass: "group-options-title"
    }, [_vm._v(_vm._s(grupo.text))]), _vm._l((grupo.funcionalidades), function(funcionalidade) {
      return _c('li', {
        class: {
          "active": funcionalidade.active
        }
      }, [_c('router-link', {
        attrs: {
          "to": funcionalidade.path
        },
        nativeOn: {
          "click": function($event) {
            return _vm.functClicked(funcionalidade, grupo)
          }
        }
      }, [_vm._v(_vm._s(funcionalidade.text))])], 1)
    })], 2)])
  })], 2)]), _c('div', {
    staticClass: "abrir-menu sidebar-bottom",
    attrs: {
      "data-toggle": "sidebar"
    },
    on: {
      "click": function($event) {
        return _vm.openCloseSidebarMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.isOpen ? "fa-chevron-left" : "fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b8ade6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8ade6c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/menu/sidebarMenu.pug
// module id = 1377
// module chunks = 0